module.exports = __webpack_public_path__ + "static/media/email-icon.c4ee8910.svg";